import * as d3 from 'd3'
export default {

  methods: {

    gauge_Actual() {

      // Gauge - Actual
      let angle = this.angle
      let circle = this.circle

      let stAngle = ''
      let proAn = (180/100) * this.rawData.PRO
    
      var arc = d3.arc()
      .innerRadius(circle.radius)
      .outerRadius(circle.radius - circle.tickness)
      .startAngle(()=> stAngle || 270 * Math.PI / 180)
      .endAngle(() => angle.end * Math.PI / 180)

      let gauge = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      gauge
      .append('path')
      .attr('transform', `translate(0, 0)`)
      .attr('d', arc).attr('fill', `#E0E0DF`).attr('opacity', 1)
      .transition().duration(500)
      .attrTween('d', ()=> {
        let stAngle_ = (270 * Math.PI / 180)
        let interpolate = d3.interpolate(stAngle_, (270+proAn) * Math.PI / 180)
        return function(t) {
          stAngle = interpolate(t)
          return arc()
        }
      })


      // Actual Cumulative Progress
      gauge
      .append('text')
      .attr('transform', `translate(0, ${this.title.pro.tSize*0.36})`)
      .attr('font-size', this.title.pro.tSize).attr('fill', this.title.pro.tColor)
      .attr('text-anchor', this.title.pro.align)
      .text(this.title.pro.name)

      let act = gauge
      .append('g')
      .attr('id', `ACTUAL_${this.localId}`)
      .attr('transform', `translate(0, 0)`)

      let col = this.columns.find(f=> f.code == 'PRO')
      act // Progress
      .append('text')
      .attr('id', `VAL_${this.localId}`)
      .attr('x', 0).attr('y', -10)
      .attr('font-size', col.tSize).attr('fill', col.tColor)
      .text(this.rawData[col.code])



      act // Unit
      .append('text')
      .attr('transform', `translate(${this.getNode(`#VAL_${this.localId}`, 'width')+3}, -10)`)
      .attr('font-size', col.uSize).attr('fill', col.uColor)
      .text(col.unit)

      d3.select(`#ACTUAL_${this.localId}`)
      .attr('transform', `translate(${-(this.getNode(`#ACTUAL_${this.localId}`, 'width')/2)}, 0)`)

      d3.select(`#VAL_${this.localId}`).text(0)
      this.gmx_textTween(`#VAL_${this.localId}`, this.rawData[col.code], 500, '', 0, -10, col.tColor, '', 1)
    },

  }
}